
import { ChangeDetectionStrategy, Component, OnDestroy, ViewChild, inject, signal } from '@angular/core';
import { RouterModule } from '@angular/router';

import { MatSidenav, MatSidenavModule } from '@angular/material/sidenav';

import { BodyClassRenderer } from '@firestitch/html';
import { BannerComponent } from '@firestitch/banner';
import { FsResizeModule } from '@firestitch/resize';

import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { LogoModule } from '@common/modules/logo';

import { SidenavService } from '../../services/sidenav.service';
import { HeaderComponent } from '../header';
import { NavbarComponent } from '../navbar';

import { SideNavBottomComponent } from './side-nav-bottom';
import { SideNavMainComponent } from './side-nav-main';


@Component({
  selector: 'app-page-side-nav',
  templateUrl: './side-nav.component.html',
  styleUrls: ['./side-nav.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    RouterModule,
    MatSidenavModule,
    BannerComponent,
    FsResizeModule,
    LogoModule,
    SideNavBottomComponent,
    SideNavMainComponent,
    HeaderComponent,
    NavbarComponent,
  ],
})
export class SideNavComponent implements OnDestroy {
  
  public sidenavService = inject(SidenavService);

  @ViewChild(MatSidenav, { static: true })
  public sidenav: MatSidenav;

  public disableClose = signal<boolean>(false);

  private _destroy$ = new Subject<void>();
  private _bodyClassRenderer = inject(BodyClassRenderer);

  constructor() {
    this._bodyClassRenderer.addClass('side-nav');
    this.disableClose.set(this.sidenavService.mode !== 'over');
    this.sidenavService.resize$
      .pipe(
        takeUntil(this._destroy$),
      )
      .subscribe(() => {
        this.disableClose.set(this.sidenavService.mode !== 'over');
        if (this.sidenavService.opened) {
          this.sidenav.open();
        }
      });
  }

  public ngOnDestroy(): void {
    this._bodyClassRenderer.removeClass('side-nav');
    this._destroy$.next();
    this._destroy$.complete();
  }

}
